function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownload = function SvgDownload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M481.3 737.3c4.6 5.6 11.5 9 18.8 9s14.2-3.3 18.8-9l273.9-337.9c3.8-4.3 6.1-9.9 6.1-16 0-13.4-10.8-24.2-24.1-24.2h-174v-335C600.8 10.8 590 0 576.6 0H423.4c-13.4 0-24.2 10.8-24.2 24.2v335.1H225.4c-9.3 0-17.8 5.4-21.8 13.8s-2.8 18.4 3 25.6z",
    style: {
      fill: "#63849f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7 855.3h910.6V1000H44.7z",
    style: {
      fill: "#76b5e4"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export default ForwardRef;